module.exports = __webpack_public_path__ + "img/ban_0.1f2598fd.png";